export default __webpack_public_path__ + "static/media/pdf.e77c543e.svg";